import { AllResponses } from '#/components/Responses/AllResponses';

export const ResponsesPage = () => {
  return <AllResponses all />;
};
